import React, {ReactElement} from "react"
import {AllowedAdjustmentsColumns} from "./Adjestments.types"
import {Adjustment} from "../../resources/adjustment"
import {Resource} from "../../resources/common"
import {Meta} from "../../resources/common"
import {DataTable, DataTableHead, DataTableBody, DataTableCell, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import AdjustmentRow from "./AdjustmentRow"
import classNames from "classnames"

interface AdjustmentsTableProps {
	adjustments: Array<Adjustment>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: Array<AllowedAdjustmentsColumns>
	meta?: Meta
	token?: string
	refresh: () => void
	fullHeight?: boolean
	singleDisputeView?: boolean
}

export default function AdjustmentsTable({
	adjustments,
	includedColumns,
	hasPrev,
	hasNext,
	prev,
	next,
	hasResults,
	isUsingPaging,
	refresh,
	meta,
	fullHeight,
	include,
}: AdjustmentsTableProps): ReactElement {
	const noContent = adjustments.length === 0

	return (
		<div className={classNames("adjustments-table")}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				noContentText={"No adjustments found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{adjustments.map((adjustment) => {
						return (
							<AdjustmentRow
								key={adjustment.id}
								adjustment={adjustment}
								refresh={refresh}
								includedColumns={includedColumns}
								included={include}
							/>
						)
					})}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
